export default __webpack_public_path__ + "static/media/drogaria-sao-paulo.9460c007.png";